
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import SelecionarTipoFrete from '@/components/Compartilhados/SelecionarTipoFrete.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { ETipoRelacaoPessoa } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoRelacaoPessoa';
import SelecionarPessoa from '@/components/Cadastros/Pessoas/SelecionarPessoa.vue';
import PedidoCompraFreteVolume from './PedidoCompraFreteVolume.vue';
import { IPedidoCompra, IPedidoCompraFreteVolume } from '@/models/Entidades/Compras/IPedidoCompra';

export default defineComponent({
  name: 'PedidoCompraFrete',
  props: {
    pedidoCompra: {
      type: Object as () => IPedidoCompra,
      required: true,
    },
    mostrarOutrosValores: {
      type: Boolean,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    selecaoManualTipoFrete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Card,
    SelecionarTipoFrete,
    CampoNumerico,
    SelecionarPessoa,
    PedidoCompraFreteVolume,
    MensagemSemDados,
  },
  emits: ['update:pedidoCompra', 'totalAlterado', 'campoAlterado', 'update:selecaoManualTipoFrete'],
  setup(props, { emit }) {
    const computedPedidoCompra = computed({
      get: () => props.pedidoCompra,
      set: (val: IPedidoCompra) => {
        emit('update:pedidoCompra', val);
      },
    });
    const computedSelecaoManualTipoFrete = computed({
      get: () => props.selecaoManualTipoFrete,
      set: (val: boolean) => {
        emit('update:selecaoManualTipoFrete', val);
      },
    });
    function totalAlterado() {
      emit('totalAlterado');
    }

    function campoAlterado() {
      emit('campoAlterado');
    }

    function adicionarVolume() {
      const volume = {} as IPedidoCompraFreteVolume;
      computedPedidoCompra.value.frete.volumes.push(volume);
    }

    function removerVolume(index: number) {
      computedPedidoCompra.value.frete.volumes.splice(index, 1);
      campoAlterado();
    }

    const state = reactive({
      codigoTransportadora: 0,
    });

    function atualizarTipoFreteManual() {
      if (props.selecaoManualTipoFrete) {
        computedSelecaoManualTipoFrete.value = true;
      }
    }
    return {
      props,
      state,
      ETipoRelacaoPessoa,
      computedPedidoCompra,
      adicionarVolume,
      campoAlterado,
      removerVolume,
      totalAlterado,
      atualizarTipoFreteManual,
    };
  },
});
